import {
  ComponentRef,
  ForwardRefRenderFunction,
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';

import { Modal } from 'shared/presentation/components/atoms';

import ScheduleConfirmation from './ScheduleConfirmation';
interface IScheduleBiometryModalRef {
  open(): void;
  close(): void;
}

interface IScheduleBiometryModalProps {
  customerId: number;
  onSuccess(): void;
  allowCancelAction?: boolean;
}

const ScheduleBiometryModal: ForwardRefRenderFunction<
  IScheduleBiometryModalRef,
  IScheduleBiometryModalProps
> = ({ customerId, onSuccess, allowCancelAction }, ref) => {
  const modalRef = useRef<ComponentRef<typeof Modal>>(null);
  const [isOpen, setIsOpen] = useState(false);

  useImperativeHandle(
    ref,
    () => ({
      open: () => {
        setIsOpen(true);
        modalRef.current?.open();
      },
      close: () => {
        setIsOpen(false);
        modalRef.current?.close();
      },
    }),
    [],
  );

  return (
    <Modal ref={modalRef} closeOnOverlayClick={false}>
      <ScheduleConfirmation
        key={customerId}
        isOpen={isOpen}
        customerId={customerId}
        allowCancelAction={allowCancelAction}
        onFinish={success => {
          setIsOpen(false);

          if (success) {
            onSuccess();
          }

          modalRef.current?.close();
        }}
      />
    </Modal>
  );
};

export default forwardRef(ScheduleBiometryModal);
